// extracted by mini-css-extract-plugin
export default {"btn":"ButtonIcon_btn__Il0Vd"};